import APILayer from './APILayer';

export interface ValidatedData {
    cbO_ID: string;
    cuid: string;
    family_ID: string;
    fn: string;
    ln: string;
    dob: string;
    zip: string;
    gender: string;
    race: string;
}

export interface ValidatedHash {
    data: ValidatedData[] | null;
    rowsSubmitted: number;
    hash: string;
}

export type ValidatedHashError = { rowNumbers: number }[] | { message: string };
export interface FileUpload {
    cbO_ID: string | null;
    cuid: string | null;
    family_ID: string | null;
    fn: string | null;
    ln: string | null;
    dob: string;
    zip: string | null;
    gender: string | null;
    race: string | null;
}

export interface ValidData {
    data: FileUpload[] | null;
    rowsSubmitted: number;
    hash: string | null;
}

export interface InvalidFileData {
    column: string | null;
    dataType: string | null;
    rowNumbers: number[] | null;
}

export interface ValidationResponse {
    fileIsValid: boolean;
    validData: ValidData;
    validationErrors: InvalidFileData[] | null;
}

export default class FileUploadAPI {
    APILayer = new APILayer();

    async postFileUpload(file: File): Promise<ValidationResponse> {
        let data = new FormData();

        data.append('File', file);

        return this.APILayer.post(`/api/FileUpload/ValidateFile`, data, true).then(async (response) => {
            if (response.status === 500) {
                throw new Error('File upload failed. Please retry.');
            }

            if (response.status === 400) {
                throw new Error('File is not valid. Please retry.');
            }

            return response.json();
        });
    }

    async submitFile(file: File, windowId: number, rowsValidated: number) {
        let data = new FormData();

        data.append('file', file);
        data.append('windowId', String(windowId));
        data.append('rowsValidated', String(rowsValidated));

        return this.APILayer.post('/api/FileUpload/Submit', data, true).then((response) => {
            if (response.status !== 200) {
                return false;
            }

            return response.json();
        });
    }
}
